import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const EditarCurso = ({ id, onClose }) => {
    // const { id } = useParams();
    const [formData, setFormData] = useState(null);
    const navigate = useNavigate();
    const [tipoCursos, setTipoCursos] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [editField, setEditField] = useState(null);

    const fieldLabels = {
        nombre: "Nombre del Curso",
        encargado: "Encargado",
        tipo_curso: "Tipo de Curso",
        fecha_inicio: "Fecha de Inicio",
        fecha_termino: "Fecha de Término",
        lugar: "Lugar",
        horario: "Horario",
        notas: "Notas",
        status: "Estado"
    };

    // --- Formatear fecha al formato ISO (aaaa-mm-dd) para que sea editable en input type="date"
    const toISODate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        return date.toISOString().split("T")[0];
    };

    // --- Convertir fecha de ISO a formato MySQL o backend (aaaa-mm-dd)
    const parseDate = (dateString) => {
        if (!dateString) return "";
        return dateString; // Ya está en formato ISO correcto
    };

    // --- Cargar datos del curso
    useEffect(() => {
        if (id) {
            axios.get(`http://192.168.1.81:5000/backend/api/cursos/${id}`)
                .then(response => {
                    const data = response.data;

                    // Convertimos las fechas para mostrarlas correctamente en inputs tipo date
                    data.fecha_inicio = toISODate(data.fecha_inicio);
                    data.fecha_termino = toISODate(data.fecha_termino);

                    // Aseguramos que el horario esté en formato HH:mm
                    if (data.horario && data.horario.length > 5) {
                        data.horario = data.horario.slice(0, 5);
                    }

                    setFormData(data);
                })
                .catch(error => {
                    alert("Curso no encontrado");
                    console.error("Error al buscar curso", error);
                    navigate("/cursos");
                });
        }
    }, [id, navigate]);

    // --- Cargar listas desplegables
    useEffect(() => {
        setTipoCursos([
            { id: "Introducción", nombre: "Introducción" },
            { id: "Taller", nombre: "Taller" },
            { id: "Capacitación", nombre: "Capacitación" }
        ]);
        setStatusList([
            { id: "Activo", nombre: "Activo" },
            { id: "Suspendido", nombre: "Suspendido" },
            { id: "Finalizado", nombre: "Finalizado" }
        ]);
    }, []);

    // --- Manejar cambios
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: ["tipo_curso", "status", "fecha_inicio", "fecha_termino", "horario"].includes(name)
                ? value
                : value.toUpperCase()
        });
    };

    // --- Manejar clic en campo editable
    const handleFieldClick = (fieldName) => {
        setEditField(fieldName);
    };

    // --- Enviar formulario
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const dataToSend = { ...formData };
            dataToSend.fecha_inicio = parseDate(dataToSend.fecha_inicio);
            dataToSend.fecha_termino = parseDate(dataToSend.fecha_termino);

            await axios.put(`http://192.168.1.81:5000/backend/api/cursos/${id}`, dataToSend);
            alert("Curso actualizado con éxito");
            navigate("/cursos");
        } catch (error) {
            alert("Error al actualizar curso");
            console.error("Error al actualizar curso", error);
        }
    };

    if (!formData) {
        return <div className="container mt-5 text-center">Cargando datos...</div>;
    }

    return (
        <div className="container mt-5">
            <div className="card shadow-lg">
                <div className="card-body">
                    <h2 className="card-title text-center mb-4">Editar Curso</h2>
                    <form onSubmit={handleSubmit}>
                        <div className="row g-3">
                            {Object.keys(formData).map((key) => (
                                <div key={key} className="col-md-6">
                                    <label className="form-label">{fieldLabels[key] || key}</label>
                                    {["tipo_curso", "status"].includes(key) ? (
                                        <select
                                            name={key}
                                            value={formData[key]}
                                            onChange={handleChange}
                                            className="form-select"
                                            required
                                        >
                                            {(key === "tipo_curso" ? tipoCursos : statusList).map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.nombre}
                                                </option>
                                            ))}
                                        </select>
                                    ) : (
                                        <input
                                            type={
                                                key.includes("fecha")
                                                    ? "date"
                                                    : key === "horario"
                                                        ? "time"
                                                        : "text"
                                            }
                                            name={key}
                                            value={formData[key]}
                                            onChange={handleChange}
                                            className="form-control"
                                            readOnly={editField !== key || key === "id"}
                                            disabled={key === "id"}
                                            onClick={() => handleFieldClick(key)}
                                            step={key === "horario" ? "60" : undefined} // formato 24h
                                            inputMode={key === "horario" ? "numeric" : undefined}
                                            pattern={key === "horario" ? "[0-9]{2}:[0-9]{2}" : undefined}
                                            lang={key === "horario" ? "es-CL" : undefined}
                                            required
                                        />
                                    )}
                                </div>
                            ))}
                        </div>
                        <button type="submit" className="btn btn-success w-100 mt-3">
                            Actualizar
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default EditarCurso;
